function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import { compose, withPropsOnChange, withHandlers, withStateHandlers } from 'recompose';
import { connect } from 'react-redux';
import { formValueSelector, isDirty, change } from 'redux-form';
import _ from 'lodash';

// Import components
import ClauseInput from "./ClauseInput";
import DropdownSelect from "../../../components/core/input/DropdownSelect";

// Import api
import { getConditionOperationsAction } from "../../../api/jsonapi";
import dispatchErrorHandler from "../../../api/dispatchErrorHandler";

// Import inputs
import TextInput from "../../../components/core/input/TextInput";
import ScoreInput from "../../../components/core/input/ScoreInput";
import CalendarInput from "../../../components/core/input/CalendarInput";
import MultiDropdownSelect from "../../../components/core/input/MultiDropdownSelect";
var mapDispatchToProps = dispatchErrorHandler({
  getConditionsOperations: function getConditionsOperations(resource, attribute) {
    return getConditionOperationsAction({
      resource: resource,
      attribute: attribute
    });
  }
});
var enhancer = compose(connect(function (state, ownProps) {
  var clause = ownProps && ownProps.clause;
  var clauseRow = formValueSelector('condition_template')(state, clause);
  var selectedResource = clauseRow && clauseRow.resource;
  var formDirty = isDirty('condition_template')(state);
  var selectedResourceDirty = isDirty('condition_template')(state, "".concat(clause, ".resource"));
  return {
    clause: clause,
    formDirty: formDirty,
    selectedResource: selectedResource,
    selectedResourceDirty: selectedResourceDirty
  };
}),
// if selectedResource has changed -> clear attribute, operator and operand
withPropsOnChange(function (oldProps, nextProps) {
  if (nextProps.selectedResourceDirty && oldProps.selectedResource && nextProps.selectedResource && oldProps.selectedResource !== nextProps.selectedResource) return true;
  return false;
}, function (_ref) {
  var clause = _ref.clause,
    dispatch = _ref.dispatch,
    selectedResourceDirty = _ref.selectedResourceDirty;
  // withPropsOnChange runs for some reason even though oldprops/nextprops is not satisfied
  if (selectedResourceDirty) {
    dispatch(change('condition_template', "".concat(clause, ".attribute"), null));
    dispatch(change('condition_template', "".concat(clause, ".operator"), null));
    dispatch(change('condition_template', "".concat(clause, ".operand"), null));
    dispatch(change('condition_template', "".concat(clause, ".operandArray"), null));
  }
}), connect(function (state, ownProps) {
  var clause = ownProps && ownProps.clause;
  var clauseRow = formValueSelector('condition_template')(state, clause);
  var selectedAttribute = clauseRow && clauseRow.attribute;
  var selectedAttributeDirty = isDirty('condition_template')(state, "".concat(clause, ".attribute"));
  return {
    selectedAttribute: selectedAttribute,
    selectedAttributeDirty: selectedAttributeDirty
  };
}),
// if selectedAttribute has changed -> clear operator and operand
withPropsOnChange(function (oldProps, nextProps) {
  if (nextProps.selectedAttributeDirty && oldProps.selectedAttribute && nextProps.selectedAttribute && oldProps.selectedAttribute !== nextProps.selectedAttribute) return true;
  return false;
}, function (_ref2) {
  var clause = _ref2.clause,
    dispatch = _ref2.dispatch,
    selectedAttributeDirty = _ref2.selectedAttributeDirty;
  // withPropsOnChange runs for some reason even though oldprops/nextprops is not satisfied
  if (selectedAttributeDirty) {
    dispatch(change('condition_template', "".concat(clause, ".operator"), null));
    dispatch(change('condition_template', "".concat(clause, ".operand"), null));
    dispatch(change('condition_template', "".concat(clause, ".operandArray"), null));
  }
}), connect(function (state, ownProps) {
  var clause = ownProps && ownProps.clause;
  var clauseRow = formValueSelector('condition_template')(state, clause);
  var selectedOperator = clauseRow && clauseRow.operator;
  var selectedOperatorDirty = isDirty('condition_template')(state, "".concat(clause, ".operator"));
  return {
    selectedOperator: selectedOperator,
    selectedOperatorDirty: selectedOperatorDirty
  };
}),
// if selectedOperator has changed -> clear operand and operandArray
withPropsOnChange(function (oldProps, nextProps) {
  if (nextProps.selectedOperatorDirty && oldProps.selectedOperator && nextProps.selectedOperator && oldProps.selectedOperator !== nextProps.selectedOperator) return true;
  return false;
}, function (_ref3) {
  var clause = _ref3.clause,
    dispatch = _ref3.dispatch,
    selectedOperatorDirty = _ref3.selectedOperatorDirty;
  if (selectedOperatorDirty) {
    dispatch(change('condition_template', "".concat(clause, ".operand"), null));
    dispatch(change('condition_template', "".concat(clause, ".operandArray"), null));
  }
}), connect(function (state, ownProps) {
  var clause = ownProps && ownProps.clause;
  var clauseRow = formValueSelector('condition_template')(state, clause);
  var selectedOperand = clauseRow && clauseRow.operand;
  var selectedOperandDirty = isDirty('condition_template')(state, "".concat(clause, ".operand"));
  return {
    selectedOperand: selectedOperand,
    selectedOperandDirty: selectedOperandDirty
  };
}),
// setup conditionAttributesOptions
withPropsOnChange(['apiConditionResourcesAttributes', 'selectedResource'], function (_ref4) {
  var apiConditionResourcesAttributes = _ref4.apiConditionResourcesAttributes,
    selectedResource = _ref4.selectedResource;
  var conditionResourceObject = apiConditionResourcesAttributes && apiConditionResourcesAttributes.length > 0 ? apiConditionResourcesAttributes.find(function (_ref5) {
    var attributes = _ref5.attributes;
    return (
      // get resource that contains attributes
      attributes.name == selectedResource
    );
  }) : {};

  // dig deeper into the nested array to get attributes_options
  var conditionAttributesOptions = conditionResourceObject && !_.isEmpty(conditionResourceObject) && conditionResourceObject.attributes && conditionResourceObject.attributes.attributes ? conditionResourceObject.attributes.attributes.map(function (attributeOption) {
    return {
      label: attributeOption.display_name,
      value: attributeOption.name
    };
  }) : [];
  return {
    conditionAttributesOptions: conditionAttributesOptions
  };
}), connect(null, mapDispatchToProps), withStateHandlers({
  apiConditionOperationsOptions: [],
  conditionsOperationsLoading: false
}, {
  setConditionsOperationsOptions: function setConditionsOperationsOptions() {
    return function (conditions) {
      return {
        apiConditionOperationsOptions: conditions
      };
    };
  },
  setConditionsOperationsLoading: function setConditionsOperationsLoading() {
    return function (_boolean) {
      return {
        conditionsOperationsLoading: _boolean
      };
    };
  }
}),
// fetch condition operation options and store in clauseinput component state instead of lazy load (status)
withHandlers({
  getConditionOperationsOptions: function getConditionOperationsOptions(_ref6) {
    var getConditionsOperations = _ref6.getConditionsOperations,
      selectedResource = _ref6.selectedResource,
      selectedAttribute = _ref6.selectedAttribute,
      setConditionsOperationsOptions = _ref6.setConditionsOperationsOptions,
      setConditionsOperationsLoading = _ref6.setConditionsOperationsLoading;
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setConditionsOperationsLoading(true);
            _context.next = 3;
            return getConditionsOperations(selectedResource, selectedAttribute).then(function (res) {
              setConditionsOperationsOptions(res && res.body && res.body.data);
            });
          case 3:
            response = _context.sent;
            setConditionsOperationsLoading(false);
            return _context.abrupt("return", response);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }
}),
// fetch condition operations options once condition modal is closed then open and selected resource and selected attribute exist
withPropsOnChange(['conditionModalVisible'], function (_ref8) {
  var conditionModalVisible = _ref8.conditionModalVisible,
    getConditionOperationsOptions = _ref8.getConditionOperationsOptions,
    selectedAttribute = _ref8.selectedAttribute,
    selectedResource = _ref8.selectedResource;
  if (conditionModalVisible && selectedResource && selectedAttribute) {
    getConditionOperationsOptions(selectedResource, selectedAttribute);
  }
}),
// fetch conditions operations options when selected attribute changes
withPropsOnChange(['selectedAttribute'], function (_ref9) {
  var getConditionOperationsOptions = _ref9.getConditionOperationsOptions,
    selectedAttribute = _ref9.selectedAttribute,
    selectedResource = _ref9.selectedResource;
  if (selectedResource && selectedAttribute) {
    getConditionOperationsOptions(selectedResource, selectedAttribute);
  }
}),
// setup conditionOperationsOptions
withPropsOnChange(['apiConditionOperationsOptions'], function (_ref10) {
  var apiConditionOperationsOptions = _ref10.apiConditionOperationsOptions;
  var conditionOperationsOptions = apiConditionOperationsOptions && apiConditionOperationsOptions.length > 0 ? apiConditionOperationsOptions.map(function (attribute) {
    return {
      label: attribute.display_name,
      value: attribute.name
    };
  }) : [];
  return {
    conditionOperationsOptions: conditionOperationsOptions
  };
}),
// set loading if conditionsOperationsOptions does not exist
withPropsOnChange(['conditionOperationsOptions', 'selectedResource', 'selectedAttribute'], function (_ref11) {
  var conditionOperationsOptions = _ref11.conditionOperationsOptions,
    selectedResource = _ref11.selectedResource,
    selectedAttribute = _ref11.selectedAttribute,
    setConditionsOperationsLoading = _ref11.setConditionsOperationsLoading;
  if ((!conditionOperationsOptions || _.isEmpty(conditionOperationsOptions)) && selectedResource && selectedAttribute) {
    setConditionsOperationsLoading(true);
  }
}),
// setup conditionOperandOptions
withPropsOnChange(['apiConditionOperationsOptions', 'selectedAttribute', 'selectedOperator'], function (_ref12) {
  var selectedOperator = _ref12.selectedOperator,
    apiConditionOperationsOptions = _ref12.apiConditionOperationsOptions;
  var conditionOperandOption = apiConditionOperationsOptions && apiConditionOperationsOptions.length > 0 ? apiConditionOperationsOptions.find(function (option) {
    return option.name == selectedOperator;
  }) : {};

  // get operand input object
  var conditionOperandObject = !_.isEmpty(conditionOperandOption) && conditionOperandOption.operand;
  var conditionOperandPattern = conditionOperandObject && conditionOperandObject.pattern;
  var conditionOperandType = conditionOperandObject && conditionOperandObject.type;

  // populate options if operand object has them
  var conditionOperandInputOptions = null;

  // if condition operand is not an array (eg. string/integer)
  if (!_.isEmpty(conditionOperandObject) && conditionOperandObject && conditionOperandObject.options) {
    conditionOperandInputOptions = conditionOperandObject.options.map(function (option) {
      return {
        label: option && option.display_name,
        value: option && option.name
      };
    });
  }

  // if conditionoperand is to be an array (eg. highest studied level)
  if (!_.isEmpty(conditionOperandObject) && conditionOperandObject && conditionOperandObject.items && conditionOperandObject.items.options) {
    conditionOperandInputOptions = conditionOperandObject.items.options.map(function (option) {
      return {
        label: option && option.display_name,
        value: option && option.name
      };
    });
  }

  // determine type of input based on required operand type from backend
  var operandInput = TextInput;
  var displayInNotInDisclaimer = false;
  var operandArray = false;
  switch (conditionOperandType) {
    case 'integer':
      operandInput = ScoreInput;
      break;
    case 'number':
      if (conditionOperandInputOptions) {
        operandInput = DropdownSelect;
      } else {
        operandInput = ScoreInput;
      }
      break;
    case 'string':
      if (conditionOperandInputOptions) {
        operandInput = DropdownSelect;
      } else if (conditionOperandPattern == '^[0-9]{4}-[0-9]{2}-[0-9]{2}$') {
        operandInput = CalendarInput;
      } else {
        operandInput = TextInput;
      }
      break;
    case 'date':
      operandInput = CalendarInput;
      break;
    case 'array':
      operandArray = true;
      if (conditionOperandInputOptions) {
        operandInput = MultiDropdownSelect;
      } else {
        displayInNotInDisclaimer = true;
        operandInput = TextInput;
      }
      break;
    case 'boolean':
      operandInput = DropdownSelect;
      conditionOperandInputOptions = [{
        value: true,
        label: 'True'
      }, {
        value: false,
        label: 'False'
      }];
      break;
    default:
      break;
  }
  return {
    conditionOperandInputOptions: conditionOperandInputOptions,
    conditionOperandObject: conditionOperandObject,
    conditionOperandType: conditionOperandType,
    displayInNotInDisclaimer: displayInNotInDisclaimer,
    operandArray: operandArray,
    operandInput: operandInput
  };
}),
// check to see if selectedOperand has changed and is required to be a number/integer, if so parse it into a integer/number for backend
withPropsOnChange(['selectedOperandDirty', 'selectedOperand', 'conditionOperandType'], function (_ref13) {
  var clause = _ref13.clause,
    conditionOperandType = _ref13.conditionOperandType,
    dispatch = _ref13.dispatch,
    selectedOperand = _ref13.selectedOperand,
    selectedOperandDirty = _ref13.selectedOperandDirty;
  if (selectedOperandDirty && selectedOperand && (conditionOperandType == 'integer' || conditionOperandType == 'number')) {
    dispatch(change('condition_template', "".concat(clause, ".operand"), parseFloat(selectedOperand)));
  }
}),
// grab selectedOperandArray
connect(function (state, ownProps) {
  var clause = ownProps && ownProps.clause;
  var clauseRow = formValueSelector('condition_template')(state, clause);
  var selectedOperandArray = clauseRow && clauseRow.operandArray;
  var selectedOperandArrayDirty = isDirty('condition_template')(state, "".concat(clause, ".operandArray"));
  return {
    selectedOperandArray: selectedOperandArray,
    selectedOperandArrayDirty: selectedOperandArrayDirty
  };
}),
// setup for selectedOperand to be an array
withPropsOnChange(['conditionOperandObject', 'selectedOperandArray', 'selectedOperandArrayDirty'], function (_ref14) {
  var clause = _ref14.clause,
    conditionOperandObject = _ref14.conditionOperandObject,
    dispatch = _ref14.dispatch,
    selectedOperandArray = _ref14.selectedOperandArray,
    selectedOperandArrayDirty = _ref14.selectedOperandArrayDirty;
  // if operator or operand array has changed and condition_operand is to be received as an array
  if (selectedOperandArrayDirty && selectedOperandArray && conditionOperandObject && conditionOperandObject.type && conditionOperandObject.type == 'array') {
    // if type of array is values from a MultiDropdownSelect
    if (!_.isEmpty(conditionOperandObject) && conditionOperandObject && conditionOperandObject.items && conditionOperandObject.items.options) {
      var formattedArray = selectedOperandArray && Array.isArray(selectedOperandArray) && selectedOperandArray.map(function (item) {
        return item.value ? item.value : item;
      });

      // change operand to reflect selected operands
      dispatch(change('condition_template', "".concat(clause, ".operand"), formattedArray));

      // clear operand array if formattedArray is false (eg. switching to in/not-in from a non-array value)
      if (!formattedArray) {
        dispatch(change('condition_template', "".concat(clause, ".operandArray"), null));
      }
    } else {
      // if type of array is values from a textinput

      // convert selectedOperandArray to string (eg. integer) so it can be split by comma
      var converted_selectedOperandArray = "".concat(selectedOperandArray);
      // convert string input into an array and filter out all falsy values
      var tempArray = converted_selectedOperandArray.split(', ').filter(Boolean);

      // formattedArray for integer setup
      var _formattedArray = tempArray;
      if (conditionOperandObject && conditionOperandObject.items && (conditionOperandObject.items.type == 'integer' || conditionOperandObject.items.type == 'number')) {
        // convert all strings to integers if condition_operand is to be an array of integers
        // have another filter if user inputs string, which converts string to NaN
        _formattedArray = tempArray && tempArray.map(function (item) {
          return parseInt(item, 10);
        }).filter(Boolean);
      }
      dispatch(change('condition_template', "".concat(clause, ".operand"), _formattedArray));
    }
  }
}),
// load in dummy operandArray input ONCE on page load (if selectedOperandArray is not dirty, empty on initialization)
// by joining selectedOperand values in a string seperated by commas
withPropsOnChange(['conditionOperandObject', 'conditionOperandType', 'selectedOperand', 'selectedOperandArrayDirty'], function (_ref15) {
  var clause = _ref15.clause,
    conditionOperandObject = _ref15.conditionOperandObject,
    conditionOperandType = _ref15.conditionOperandType,
    dispatch = _ref15.dispatch,
    selectedOperand = _ref15.selectedOperand,
    selectedOperandArrayDirty = _ref15.selectedOperandArrayDirty;
  if (!selectedOperandArrayDirty && selectedOperand && conditionOperandType == 'array') {
    // if operand is a multiselect leave it the way it is
    var joinedArray = selectedOperand;

    // if operand coming in is not a multiselect
    if (!(!_.isEmpty(conditionOperandObject) && conditionOperandObject && conditionOperandObject.items && conditionOperandObject.items.options)) {
      joinedArray = selectedOperand && selectedOperand.length > 0 && selectedOperand.join(', ');
    }
    dispatch(change('condition_template', "".concat(clause, ".operandArray"), joinedArray));
  }
}));
export default enhancer(ClauseInput);